import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {Publication, PublicationService} from "../../../services/publication.service";

@Component({
    selector: 'app-blog-page',
    templateUrl: './blog-page.component.html',
    styleUrls: ['./blog-page.component.scss']
})
export class BlogPageComponent implements OnInit, OnDestroy {
    type!: 'PROJECT' | 'BLOG';
    name!: string;
    smallName!: string;

    enterprise: string = "ASESA";
    publications: (Publication & { previewUrl?: string })[] = [];
    loading = false;

    private subs: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private publicationService: PublicationService
    ) {}

    ngOnInit(): void {
        // type fourni par le routing data
        this.type = this.route.snapshot.data['type'] ?? 'PROJECT';

        if (this.type === 'PROJECT') {
            this.name = 'Projets';
            this.smallName = 'Projet';
        } else {
            this.name = 'Actualités';
            this.smallName = 'Actualite';
        }

        this.loadPublications();
    }

    private loadPublications(): void {
        this.loading = true;
        const s = this.publicationService.getAllByType(this.type, this.enterprise).subscribe({
            next: (data) => {
                this.publications = data;

                // Charger l'image principale (si dispo) pour chaque publication
                for (const pub of this.publications) {
                    const subImg = this.publicationService
                        .getFirstImage(pub.enterprise, pub.type, pub.id)
                        .subscribe({
                            next: (blob) => (pub.previewUrl = URL.createObjectURL(blob)),
                            error: () => (pub.previewUrl = 'assets/img/placeholder.png')
                        });
                    this.subs.push(subImg);
                }
            },
            complete: () => (this.loading = false),
            error: () => (this.loading = false)
        });
        this.subs.push(s);
    }

    ngOnDestroy(): void {
        // libérer les ObjectURL si créés
        for (const p of this.publications) {
            if (p.previewUrl?.startsWith('blob:')) {
                URL.revokeObjectURL(p.previewUrl);
            }
        }
        this.subs.forEach(s => s.unsubscribe());
    }
}
